var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"container"},_vm._l((_vm.list),function(item,i){return _c('li',{key:i,staticClass:"container_img"},[_c('img',{attrs:{"src":item.url,"alt":item.title}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }